import { render, staticRenderFns } from "./StudentClassroomSelected.vue?vue&type=template&id=02f692cf&"
import script from "./StudentClassroomSelected.vue?vue&type=script&lang=js&"
export * from "./StudentClassroomSelected.vue?vue&type=script&lang=js&"
import style0 from "./StudentClassroomSelected.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports